var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.referrals.length)?_c('div',{staticClass:"product-referral"},[_c('h3',{staticClass:"title"},[_vm._v("Customers also booked these items")]),_c('div',{staticClass:"referral-container"},_vm._l((_vm.referrals),function(r,ix){return _c('product-card',{key:ix,attrs:{"product":r}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }